import {
  DELETE_KEG_COLLECTION_REQUEST,
  DELETE_KEG_COLLECTION_SUCCESS,
  DELETE_KEG_COLLECTION_FAILURE,
  DELETE_KEG_COLLECTION_CLEAR,
  DELETE_KEG_COLLECTION_QUEUE,
} from '../../../actions/actionTypes'

import fetchStatusReducerCreator from '../../fetchStatuses/higherOrderReducers/reducerCreators'

export default fetchStatusReducerCreator({})(
    DELETE_KEG_COLLECTION_REQUEST,
    DELETE_KEG_COLLECTION_SUCCESS,
    DELETE_KEG_COLLECTION_FAILURE,
    DELETE_KEG_COLLECTION_CLEAR,
    DELETE_KEG_COLLECTION_QUEUE
)
